import React from 'react';
import styled from 'styled-components';
import AppBar from '../components/AppBar/AppBar';
import Footer from '../components/Footer/Footer'

const NotFoundContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`
const NotFoundCaption = styled.div`
    display: flex;
    text-align: center;
    color: white;
    margin: 30px;
    justify-content: center;
    font-size: 75px;
    align-items: center;
    position: relative;
    top: 10vh;

`
const Content= styled.div`
    background-color: black;
    height: 100%;
`
const Return = styled.a`
    display: flex;
    background-color: #f44336;
    color: white;
    padding: 14px 25px;
    align-items: center;
    text-align: center;
    text-decoration: none;
    display: inline-flex;
    margin-left: 5px;
    font-size: 20px;
`
const NotFound = () => {

  return (
      <>
        <NotFoundContainer>
            <Content>
            <AppBar />
            <NotFoundCaption>
                404
                <Return href='/page5'>Task 5</Return>  
                <Return href='/dashpage'>Demo Dashboard</Return>  
                
            </NotFoundCaption>
            </Content>
            <Footer />
        </NotFoundContainer>
      </>
  );
};

export default NotFound;
